import { getLiveChatTemplate, getVueLiveChatTemplate } from "../../shortcodes/templates";

let liveChatShortcode = null;
const visualizeLiveChat = content => {
  liveChatShortcode = content.querySelectorAll('[data-wrapper-id="live-chat-shortcode"]');

  if (liveChatShortcode.length > 0) {
    liveChatShortcode.forEach(item => {
      item.innerHTML = getLiveChatTemplate();
    });
  }
};

const serializeLiveChat = content => {
  const liveChatShortcode = content.querySelectorAll('[data-wrapper-id="live-chat-shortcode"]');
  if (liveChatShortcode.length > 0) {
    liveChatShortcode.forEach(item => {
      const liveChatData = item.getAttribute("data-live-chat-data");
      item.innerHTML = getVueLiveChatTemplate(liveChatData);
    });
  }
};

export { visualizeLiveChat, serializeLiveChat };
